import { FC, ReactElement } from 'react';
import { GoForwardButtonBase } from './shared/GoForwardButtonBase';

interface Props {
  addBackButton?: boolean;
  isMobile?: boolean;
  onForwardClick?: () => void;
  mobileText?: string;
  disabled?: boolean;
  desktopText?: string;
  Icon?: FC;
  validate?: () => boolean;
  tipo?: 'button' | 'reset' | 'submit';
}

export function GoForwardButton({
  addBackButton = false,
  isMobile = false,
  onForwardClick,
  disabled = false,
  mobileText = 'Avançar',
  desktopText = 'Continuar',
  Icon,
  validate,
  tipo,
}: Props): ReactElement {
  return (
    <GoForwardButtonBase
      addBackButton={addBackButton}
      isMobile={isMobile}
      onForwardClick={onForwardClick}
      disabled={disabled}
      mobileText={mobileText}
      desktopText={desktopText}
      Icon={Icon}
      validate={validate}
      type={tipo}
      containerClassName="w-full min-[748px]:mt-16 mt-24 relative flex min-[748px]:justify-end justify-center gap-6"
    />
  );
}
